<div class="contain" *ngIf="displayInput">
    <label *ngIf="!isJustUserInput" translate>chooseRecipient.mailBody.to</label>
    <div class="select-inputs">
        <div class="warp-input-select" #autoUsers (click)="openSelectUser=true">
            <input class="select" type="text" placeholder="{{'chooseRecipient.placeholder.contact' | translate}}"
                matInput [formControl]="myControl">
        </div>
        <ng-template #titleEditNoOpen cdkConnectedOverlay [cdkConnectedOverlayOrigin]="autoUsers"
            [cdkConnectedOverlayHasBackdrop]="true" [cdkConnectedOverlayOpen]="true"
            cdkConnectedOverlayBackdropClass="backdrop-selection" (backdropClick)="openSelectUser=false"
            [cdkConnectedOverlayOpen]="openSelectUser" [cdkConnectedOverlayPositions]="positonArea">
            <div class="overlay-warp">
                <ng-container *ngIf="!loadingUsers$() else loading">
                    <div n *ngFor="let user of users$();let i=index" (click)=" onContactSelected(user)">
                        <que-mini-contact-display [user]="user" [isSelect]="true"></que-mini-contact-display>
                    </div>
                    <div *ngIf="users$()?.length==0">
                        <span *ngIf="isInPublish" translate>no-result.not-found-or-exist-user</span>
                        <span *ngIf="!isInPublish" translate>no-result.not-found-or-added-user</span>
                    </div>
                </ng-container>
            </div>
        </ng-template>
        <div class="orLable" *ngIf="!isJustUserInput">
            <lable translate>chooseRecipient.or</lable>
        </div>
        <ng-container *ngIf="!isJustUserInput">
            <div class="warp-input-select" #autoGroup (click)="openSelectTeams=true" [ngClass]="{fullWidth:isJustUserInput}">
                <input class="select" type="text" placeholder="{{'chooseRecipient.placeholder.group' | translate}}"
                    matInput [formControl]="myControlGroups">
            </div>
            <ng-template #titleEditNoOpen cdkConnectedOverlay [cdkConnectedOverlayOrigin]="autoGroup"
                [cdkConnectedOverlayHasBackdrop]="true" [cdkConnectedOverlayOpen]="true"
                cdkConnectedOverlayBackdropClass="backdrop-selection" (backdropClick)="openSelectTeams=false"
                [cdkConnectedOverlayOpen]="openSelectTeams" [cdkConnectedOverlayPositions]="positonArea">
                <div class="overlay-warp">
                    <ng-container *ngIf="!loadingGroups$() else loading">
                        <div *ngFor="let group of groups$();let i=index" (click)=" onGroupSelected(group)">
                            <que-group-display [group]="group" [displayUsers]="false"
                                [isSelect]="true"></que-group-display>
                        </div>
                        <div *ngIf="groups$()?.length==0">
                            <span *ngIf="isInPublish" translate>no-result.not-found-or-exist-group</span>
                            <span *ngIf="!isInPublish" translate>no-result.not-found-or-added-group</span>
                        </div>
                    </ng-container>
                </div>
            </ng-template>
        </ng-container>
        <!-- <div class="btn" (click)="addContact()">
        <p translate>btns.add</p>
        <img src="/assets/images/popup-recipient/add.svg">
    </div> -->
    </div>
</div>
<div class="contact-and-groups" *ngIf="!isJustUserInput">
    <div *ngIf="distributionGroup$ | async as groups" class="groups">
        <p id="p" *ngIf="groups.length>0" translate>chooseRecipient.groups</p>
        <que-group-display [canDelete]="canDelete || isNewGroup(g.id)" *ngFor="let g of groups, let i= index"
            [group]="g"></que-group-display>
    </div>
    <div class="contacts">
        <div *ngIf="recipients$ | async as recipient">
            <p id="p" *ngIf="recipient.length>0" translate>chooseRecipient.contact</p>
            <que-contact-display [canDelete]="canDelete || isNewUser(r.user.id)"
                *ngFor="let r of recipient, let i= index" [contact]="r.user"></que-contact-display>
        </div>
    </div>
</div>

<ng-template #loading>
    <div class="load-warp ">
        <div class="load-item" *ngFor="let _ of [].constructor(4)"></div>
    </div>
</ng-template>